import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	returnToItAnytime: {
		id: 'polaris-components-quickstart.onboarding-check-list.return-to-it-anytime',
		defaultMessage: 'Return to it anytime from your user profile.',
		description: 'Text explaining how to access the checklist later',
	},
});
